import { RegisterModule } from '@/typings/common'
import {
  Topic as Data,
  TopicCollection as Collection,
} from '@/typings/api/Topic'
import { TopicsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { MODULE_NAME } from '../utils'
import { TopicsAdapter } from './TopicsAdapter'


const useOptions = () => ({
  adapter: new TopicsAdapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as topicsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
